import styled from 'styled-components';

export const VisitFeature = styled.section`
  padding: 5rem 0;
  background-color: #fff;
  overflow: hidden;

  .btn-position {
    @media (max-width: 767px) {
      position: relative;
      padding-bottom: 80px;

      .cta-wrapper {
        position: absolute;
        left: 15px;
        right: 15px;
        text-align: center;
        bottom: 0;

        a {
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .btn-static {
    @media (max-width: 767px) {
      position: static;
    }
  }

  .lazy-load-image-background {
    max-width: 100%;
    height: 100%;
    display: block !important;
  }

  @media (max-width: 1199.98px) {
    padding: 50px 0;
  }

  @media (max-width: 991.98px) {
    padding: 0 0 3rem;
  }

  &.tabgroup_section {
    padding: 50px 0 0;
  }

  &.venue_graybg {
    background-color: #f7f7f7;
    margin-top: 50px;
    padding: 50px 0 100px;

    @media (max-width: 1199.98px) {
      padding: 50px 0;
    }

    @media (max-width: 991.98px) {
      padding: 0 0 3rem;
    }
  }

  &.exhibit_grey {
    background-color: #f7f7f7;
    padding: 5rem 0;

    @media (max-width: 1199.98px) {
      padding: 50px 0;
    }

    @media (max-width: 991.98px) {
      padding: 0 0 3rem;
    }
  }

  &.row_reverse {
    div[class*='Rowstyled__Row-'] {
      flex-direction: row-reverse;
    }
  }

  &.bg_gray {
    background-color: #f7f7f7;
  }

  &.trip_planner {
    overflow: hidden;
  }
`;

export const SectionInnerCaption = styled.div`
  text-align: center;
  padding-bottom: 2rem;

  @media (min-width: 1200px) {
    padding-bottom: 5rem;
  }

  h2 {
    color: #4a4a4a;
    margin-bottom: 0;

    @media (max-width: 1400px) {
      line-height: 40px;
    }

    @media (max-width: 1200px) {
      font-size: 26px;
      line-height: 30px;
    }

    @media (max-width: 992px) {
      margin: 0;
      padding-top: 3rem;
    }
  }
`;

export const ImgCenter = styled.div`
  display: flex;
  height: 100%;
  flex-flow: column;
  justify-content: center;
  .lazy-load-image-background {
    height: auto;
  }
`;
